import {generateAdobeId} from '@ox/data';
import {ErrorInfo, FormAbstractClass, FormObject} from '@ox/typings';


export class EditPaymentTrackingData extends FormAbstractClass {
    
    constructor(){  
        const removeVehicleSurveyGeneric = {
            id: 'edit-payment',
            name: 'edit payment',
            fieldName:'removal-reason',
            interactionType: '',
            location:'place-holder'
        };
        super(removeVehicleSurveyGeneric); 
    }

    public start = (id:string = this.getGenericForm().id): FormObject => ({
            ...this.getGenericForm(),
            id: generateAdobeId(id),
            interactionType: 'edit-payment-start'
    });

    public update = (fieldName = this.getGenericForm().fieldName): FormObject => ({
        ...this.getGenericForm(),
        id: generateAdobeId('edit-payment-update'),
        interactionType: 'edit-payment-update',
        fieldName:fieldName
    });
    public error = (error?:Error): ErrorInfo => ({
        errorId: generateAdobeId('edit-payment-error'),
        errorType: 'user-input',
        errorCode: 'edit-payment.serverError',
        errorMessage: error && error.message ? error.message : '',
        errorLocation: 'place-holder',
        integrationId: 'edit-payment-api-error',
        platformId:''
    });
    public cancel = (): FormObject => ({
        ...this.getGenericForm(),
        id: generateAdobeId('edit-payment-cancel'),
        interactionType: 'edit-payment-cancel'
    });
    public complete = (): FormObject => ({
        ...this.getGenericForm(),
        id: generateAdobeId('edit-payment-complete'),
        interactionType: 'edit-payment-complete'
    });
    
}
